export const useDropDownHandler = () => {
    const hoveredOnMenuItems = useState<boolean>("hoveredOnMenuItems", () => false);
    const { isDesktop } = useDevice();

    const handleMouseLeave = (event: MouseEvent, open: boolean, close: () => void) => {
        if (isDesktop) {
            setTimeout(() => {
                return open && hoveredOnMenuItems.value ? "" : close();
            }, 100);
        }
    };

    const handleMouseEnter = (event: MouseEvent, open: boolean) => {
        if (isDesktop) {
            // @ts-ignore
            return open ? "" : event.target?.click();
        }
    };

    const handleMenuItemsMouseLeave = (close: () => void) => {
        if (isDesktop) {
            hoveredOnMenuItems.value = false;
            close();
        }
    };

    const handleMenuItemsMouseEnter = () => {
        hoveredOnMenuItems.value = true;
    };

    return {
        handleMouseEnter,
        handleMouseLeave,
        hoveredOnMenuItems,
        handleMenuItemsMouseEnter,
        handleMenuItemsMouseLeave,
    };
};
